require('./pagination-template.html');

angular.module('bbl.directives.pagination', [])

.directive('pagination', [function() {
	return {
		restrict: 'EA',
		scope: {
			items: '=',
			take: '=',
			cPage: '=',
			onChange: '&',
		},
		templateUrl: 'pagination-template.html',
		link: function($scope, $el, atts) {
			var onPageChange = $scope.onChange || angular.noop;

			function pagination(c, m) {
			    var current = c,
			        last = m,
			        delta = 2,
			        left = current - delta,
			        right = current + delta + 1,
			        range = [],
			        rangeWithDots = [],
			        l, i;

			    for (i = 1; i <= last; i++) {
			        if (i == 1 || i == last || i >= left && i < right) {
			            range.push(i);
			        }
			    }

			    for (var _i in range) {
			    	i = range[_i];
			        if (l) {
			            if (i - l === 2) {
			                rangeWithDots.push(l + 1);
			            } else if (i - l !== 1) {
			                rangeWithDots.push('...');
			            }
			        }
			        rangeWithDots.push(i);
			        l = i;
			    }

			    return rangeWithDots;
			}

			$scope.getMax = function() {
				return Math.ceil($scope.items/$scope.take);
			};

			$scope.getPages = function() {
				return pagination($scope.cPage, $scope.getMax());
			};

			$scope.goTo = function(n) {
				$scope.cPage = n;
				onPageChange({$event: $scope.cPage});
			};
		}
	};
}])

.filter('pag', function () {
	return function (list, take, page) {
		if(!(list && Array.isArray(list))) {
			list = [];
		}

		if(!take || typeof take === 'object') {
			var cfg = take || {};
			take = cfg.take || 10;
			page = cfg.page;
		}

		page = page || 0;

		return list.slice(page*take, page*take+take);
	};
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/pagination.js
 ** module id = 169
 ** module chunks = 0
 **/